let wrapperElementName = `nss-modal-wrapper`;
if (typeof customElements.get(wrapperElementName) === `undefined`) {
  class NSSModalWrapper extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }
    connectedCallback() {
      const modal = this.querySelector("nss-modal");

      if (!modal) return;

      if (this.parentElement !== document.body) {
        // document.body.appendChild(modal);
      }
    }
  }

  customElements.define(wrapperElementName, NSSModalWrapper);
}

// Delegated triggers: per-element listeners duplicated after section re-renders.
if (!window.__nssModalDelegated) {
  window.__nssModalDelegated = true;
  document.addEventListener(`click`, (e) => {
    const trigger = e.target.closest(`.js-nss-modal-trigger`);
    if (!trigger) return;
    const id = trigger.getAttribute(`data-modal`);
    if (!id) return;
    const modal = [...document.querySelectorAll(`nss-modal[data-modal="${CSS.escape(id)}"]`)].find(
      (m) => m.isConnected
    );
    if (!modal || typeof modal.openDialog !== `function`) return;
    e.preventDefault();
    modal.openDialog();
  });
}

let elementName = `nss-modal`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(
    elementName,
    class NSSModal extends HTMLElement {
      constructor() {
        super();

        this.debug = false;

        this.selectors = {
          trigger: ".js-nss-modal-trigger",
          closeButton: ".js-nss-modal-close",
          dialog: ".js-nss-modal-dialog",
          video: "video",
        };

        this.dataModal = this.getAttribute("data-modal");

        this.closeButton = this.querySelectorAll(this.selectors.closeButton);
        this.dialog = this.querySelector(this.selectors.dialog);
        this.video = this.querySelector(this.selectors.video);

        this.allButtons = this.querySelectorAll("a, button");
        this.firstFocusableElement = this.allButtons[0];
        this.lastFocusableElement = this.allButtons[this.allButtons.length - 1];

        this.html = document.documentElement;

        this.init();
      }

      portalToBody() {
        if (this.parentElement === document.body) return;
        this._homeParent = this.parentElement;
        this._homeNext = this.nextSibling;
        document.body.appendChild(this);
      }

      restoreHome() {
        if (this.parentElement !== document.body) return;
        if (this._homeParent && this._homeParent.isConnected) {
          this._homeParent.insertBefore(this, this._homeNext);
        } else {
          this.remove();
        }
        this._homeParent = null;
        this._homeNext = null;
      }

      restoreHomeAfterTransition() {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          this.removeEventListener("transitionend", finish);
          this.restoreHome();
        };
        this.addEventListener("transitionend", finish);
        setTimeout(finish, 400);
      }


      playVideo() {
        if (!this.video) return;

        if (this.video.tagName === "VIDEO") {
          this.video.play();
        }

        if (this.video.tagName === "IFRAME") {
          const src = this.video.getAttribute("src");
          if (!src.includes("autoplay=1")) {
            const join = src.includes("?") ? "&" : "?";
            this.video.setAttribute("src", `${src}${join}autoplay=1`);
          }
        }
      }

      stopVideo() {
        this.querySelectorAll("video").forEach((v) => {
          try {
            v.pause();
            v.currentTime = 0;
          } catch (e) {}
        });
        this.querySelectorAll("iframe").forEach((f) => {
          const src = f.getAttribute("src");
          if (src) f.setAttribute("src", src);
        });
      }


      openDialog() {
        this.portalToBody();
        requestAnimationFrame(() => this.classList.add("is-visible"));
        this.html.classList.add("is-nss-modal-show");
        this.playVideo();
        this.closeButton[0]?.focus();
      }

      closeDialog() {
        this.classList.remove("is-visible");
        this.html.classList.remove("is-nss-modal-show");
        this.stopVideo();
        document
          .querySelector(`${this.selectors.trigger}[data-modal="${this.dataModal}"]`)
          ?.focus();
        this.restoreHomeAfterTransition();
      }


      init() {
        this.closeButton.forEach((el) => {
          el.addEventListener("click", () => {
            this.closeDialog();
          });
        });

        this.addEventListener("click", (e) => {
          if (!this.dialog.contains(e.target)) {
            this.closeDialog();
          }
        });

        this.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            this.closeDialog();
          }
        });

        this.dialog?.addEventListener("keydown", (e) => {
          if (e.key === "Tab" && e.shiftKey && e.target === this.firstFocusableElement) {
            e.preventDefault();
            this.lastFocusableElement.focus();
          }

          if (e.key === "Tab" && !e.shiftKey && e.target === this.lastFocusableElement) {
            e.preventDefault();
            this.firstFocusableElement.focus();
          }
        });
      }
    }
  );
}
